// src/components/report/PartA1.jsx
import React from 'react';

const PartA1 = ({data, pageNumber}) => {
    const na = <span className="text-gray-400">-</span>;

    const renderClassCheckboxes = (currentClassValue, options) => {
        return options.map(opt => (
            <label key={opt.id} className="flex items-center space-x-1 mr-4">
                <input type="checkbox" className="custom-checkbox" readOnly
                       checked={currentClassValue === opt.id || currentClassValue === opt.label}/>
                <span className="text-xs text-gray-800">{opt.label}</span>
            </label>
        ));
    };

    const classOptions = [
        {id: 'BV1', label: 'BV1'}, {id: 'BV2', label: 'BV2'}, {id: 'BV3', label: 'BV3'},
        {id: 'Grade 1', label: 'Grade 1'}, {id: 'Grade 2', label: 'Grade 2'},
    ];

    const interestOptions = [
        {id: 'reading', label: 'Reading'},
        {id: 'dancing_singing_instrument', label: 'Dancing or Singing or Playing a musical instrument'},
        {id: 'sport_games', label: 'Sport or Games'},
        {id: 'creative_writing', label: 'Creative writing'},
        {id: 'gardening', label: 'Gardening'},
        {id: 'yoga', label: 'Yoga'},
        {id: 'art', label: 'Art'},
        {id: 'craft', label: 'Craft'},
        {id: 'cooking', label: 'Cooking'},
        {
            id: 'chores',
            label: 'Regular chores at home with significant others (father, mother, guardian, sibling, etc.)'
        },
    ];

    return (
        <div className="report-page relative bg-white" style={{
            width: '210mm',
            height: '297mm',
            minHeight: '297mm',
            padding: '15mm 20mm',
            margin: '0 auto',
            fontSize: '10pt',
            lineHeight: '1.4',
            fontFamily: 'Arial, Helvetica, sans-serif',
            color: '#333333',
            boxSizing: 'border-box',
            overflow: 'hidden'
        }}>
            {/* Orange corner triangles - matching reference exactly */}
            <div className="absolute top-0 right-0 w-0 h-0"
                 style={{
                     borderTop: '80px solid #F97316',
                     borderLeft: '80px solid transparent'
                 }}>
            </div>
            <div className="absolute bottom-0 left-0 w-0 h-0"
                 style={{
                     borderBottom: '80px solid #F97316',
                     borderRight: '80px solid transparent'
                 }}>
            </div>

            {/* Title */}
            <h2 className="text-center font-bold text-xl text-orange-600 mb-6 mt-2">PART-A (1)</h2>

            {/* School Info Header Block */}
            <div className="mb-4">
                <div className="flex justify-between items-start mb-3">
                    <div className="w-3/5">
                        <div className="font-bold mb-1 text-sm">Name and Address of the School:</div>
                        <div
                            className="border-b border-gray-600 min-h-[1.5em] mb-1 text-sm">{data?.school_name || ''}</div>
                        <div className="border-b border-gray-600 min-h-[1.5em] text-sm"></div>
                    </div>
                    <div className="w-2/5 pl-4">
                        <div className="font-bold mb-1 text-right text-sm">Pin Code:</div>
                        <div className="flex justify-end">
                            {[...Array(6)].map((_, i) => (
                                <div key={i}
                                     className="w-6 h-6 border border-gray-600 mx-0.5 flex items-center justify-center text-sm font-medium">
                                    {data?.pin_code && data.pin_code[i] ? data.pin_code[i] : ''}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="flex justify-between items-center mb-3">
                    <div>
                        <div className="font-bold mb-1 text-sm">UDISE Code:</div>
                        <div className="flex">
                            {[...Array(11)].map((_, i) => (
                                <div key={i}
                                     className="w-6 h-6 border border-gray-600 mr-0.5 flex items-center justify-center text-sm font-medium">
                                    {data?.udise_code && data.udise_code[i] ? data.udise_code[i] : ''}
                                </div>
                            ))}
                        </div>
                    </div>
                    <div>
                        <div className="font-bold mb-1 text-right text-sm">Teacher Code:</div>
                        <div className="flex justify-end">
                            {[...Array(3)].map((_, i) => (
                                <div key={i}
                                     className="w-6 h-6 border border-gray-600 mx-0.5 flex items-center justify-center text-sm font-medium">
                                    {data?.teacher_code && data.teacher_code[i] ? data.teacher_code[i] : ''}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="mb-4">
                    <div className="font-bold text-sm mb-1">APAAR ID:</div>
                    <div
                        className="border-b-2 border-gray-800 min-h-[1.5em] text-sm font-medium">{data?.apaar_id || ''}</div>
                </div>
            </div>

            {/* GENERAL INFORMATION Header */}
            <div className="bg-orange-600 text-white py-2 px-4 text-center font-bold text-base mb-1"
                 style={{marginLeft: '-20mm', marginRight: '-20mm'}}>
                GENERAL INFORMATION
            </div>
            <div className="text-xs text-gray-600 mb-4 italic text-center">
                (To be filled by the teacher in consultation with caregiver/parent)
            </div>

            {/* Student Information with Photograph */}
            <div className="flex justify-between items-start mb-4">
                <div className="w-[calc(100%-120px)] pr-4">
                    <div className="mb-3">
                        <div className="flex items-center">
                            <div className="w-32 font-bold text-sm">Student Name:</div>
                            <div
                                className="flex-1 border-b border-gray-600 min-h-[1.5em] text-sm font-medium pl-2 pb-1">{data?.student_name || ''}</div>
                        </div>
                    </div>

                    <div className="mb-3 flex">
                        <div className="w-24 font-bold text-sm">Roll No.</div>
                        <div
                            className="w-32 border-b border-gray-600 min-h-[1.5em] text-sm font-medium mr-4 pl-2 pb-1">{data?.roll_no || ''}</div>
                        <div className="w-32 font-bold text-sm">Registration No.:</div>
                        <div
                            className="flex-1 border-b border-gray-600 min-h-[1.5em] text-sm font-medium pl-2 pb-1">{data?.registration_no || ''}</div>
                    </div>

                    <div className="mb-3">
                        <div className="flex items-center">
                            <div className="font-bold mr-4 text-sm">Class:</div>
                            <div className="flex flex-wrap">
                                {renderClassCheckboxes(data?.class_grade, classOptions)}
                            </div>
                        </div>
                    </div>

                    <div className="mb-3 flex">
                        <div className="w-24 font-bold text-sm">Section:</div>
                        <div
                            className="w-32 border-b border-gray-600 min-h-[1.5em] text-sm font-medium mr-4 pl-2 pb-1">{data?.section || ''}</div>
                        <div className="w-32 font-bold text-sm">Date of Birth:</div>
                        <div
                            className="flex-1 border-b border-gray-600 min-h-[1.5em] text-sm font-medium pl-2 pb-1">{data?.date_of_birth || ''}</div>
                    </div>

                    <div className="mb-3">
                        <div className="flex items-center">
                            <div className="w-24 font-bold text-sm">Address:</div>
                            <div
                                className="flex-1 border-b border-gray-600 min-h-[1.5em] text-sm font-medium pl-2 pb-1">{data?.address || ''}</div>
                        </div>
                    </div>

                    <div className="mb-3">
                        <div className="flex items-center">
                            <div className="flex-1 border-b border-gray-600 min-h-[1.5em]"></div>
                            <div className="w-24 font-bold text-sm text-right ml-4">Phone:</div>
                        </div>
                        <div
                            className="border-b border-gray-600 min-h-[1.5em] text-sm font-medium mt-1 pl-2 pb-1">{data?.phone || ''}</div>
                    </div>
                </div>
                <div
                    className="w-[100px] h-[120px] border-2 border-gray-600 flex flex-col items-center justify-center bg-gray-50 text-center">
                    <div className="text-sm font-bold">Photograph</div>
                </div>
            </div>

            {/* Guardian Information */}
            <div className="space-y-3 mb-4">
                <div className="flex items-center">
                    <div className="w-48 font-bold text-sm">Mother/Guardian Name:</div>
                    <div
                        className="flex-1 border-b border-gray-600 min-h-[1.5em] text-sm font-medium pl-2 pb-1">{data?.mother_name || ''}</div>
                </div>

                <div className="flex items-center">
                    <div className="w-48 font-bold text-sm">Mother/Guardian Education:</div>
                    <div
                        className="w-32 border-b border-gray-600 min-h-[1.5em] text-sm font-medium mr-4 pl-2 pb-1">{data?.mother_education || ''}</div>
                    <div className="w-48 font-bold text-sm">Mother/Guardian Occupation:</div>
                    <div
                        className="flex-1 border-b border-gray-600 min-h-[1.5em] text-sm font-medium pl-2 pb-1">{data?.mother_occupation || ''}</div>
                </div>

                <div className="flex items-center">
                    <div className="w-48 font-bold text-sm">Father/Guardian Name:</div>
                    <div
                        className="flex-1 border-b border-gray-600 min-h-[1.5em] text-sm font-medium pl-2 pb-1">{data?.father_name || ''}</div>
                </div>

                <div className="flex items-center">
                    <div className="w-48 font-bold text-sm">Father/Guardian Education:</div>
                    <div
                        className="w-32 border-b border-gray-600 min-h-[1.5em] text-sm font-medium mr-4 pl-2 pb-1">{data?.father_education || ''}</div>
                    <div className="w-48 font-bold text-sm">Father/Guardian Occupation:</div>
                    <div
                        className="flex-1 border-b border-gray-600 min-h-[1.5em] text-sm font-medium pl-2 pb-1">{data?.father_occupation || ''}</div>
                </div>
            </div>

            {/* Other Details */}
            <div className="grid grid-cols-2 gap-x-8 mb-4">
                <div className="flex items-center">
                    <div className="w-36 font-bold text-sm">Number of siblings:</div>
                    <div
                        className="flex-1 border-b border-gray-600 min-h-[1.5em] text-sm font-medium pl-2 pb-1">{data?.number_of_siblings || ''}</div>
                </div>
                <div className="flex items-center">
                    <div className="w-28 font-bold text-sm">Siblings' age:</div>
                    <div
                        className="flex-1 border-b border-gray-600 min-h-[1.5em] text-sm font-medium pl-2 pb-1">{data?.siblings_age?.join(', ') || ''}</div>
                </div>
                <div className="flex items-center">
                    <div className="w-36 font-bold text-sm">Mother Tongue:</div>
                    <div
                        className="flex-1 border-b border-gray-600 min-h-[1.5em] text-sm font-medium pl-2 pb-1">{data?.mother_tongue || ''}</div>
                </div>
                <div className="flex items-center">
                    <div className="w-28 font-bold text-sm">Medium of Instruction:</div>
                    <div
                        className="flex-1 border-b border-gray-600 min-h-[1.5em] text-sm font-medium pl-2 pb-1">{data?.medium_of_instruction || ''}</div>
                </div>
                <div className="flex items-center">
                    <div className="w-36 font-bold text-sm">Rural/Urban:</div>
                    <div
                        className="flex-1 border-b border-gray-600 min-h-[1.5em] text-sm font-medium pl-2 pb-1">{data?.rural_or_urban || ''}</div>
                </div>
            </div>

            {/* Attendance Table */}
            <div className="mb-4">
                <div className="bg-orange-500 text-white py-1 px-3 text-sm font-bold inline-block mb-2">
                    ATTENDANCE
                </div>
                <table className="w-full border-collapse">
                    <thead>
                    <tr>
                        {['MONTHS', 'APR', 'MAY', 'JUNE', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC', 'JAN', 'FEB', 'MAR'].map(m => (
                            <th key={m}
                                className="border border-gray-800 bg-orange-200 text-orange-900 p-1 text-center text-xs font-bold">
                                {m}
                            </th>
                        ))}
                    </tr>
                    </thead>
                    <tbody>
                    {['No. of Working Days', 'No. of Days Attended', '% of Attendance'].map((label, idx) => (
                        <tr key={idx}>
                            <td className="border border-gray-800 bg-orange-100 p-1 text-xs font-bold text-orange-900">{label}</td>
                            {Array(12).fill('').map((_, i) => (
                                <td key={i} className="border border-gray-800 p-1 text-center h-6"></td>
                            ))}
                        </tr>
                    ))}
                    <tr>
                        <td colSpan="13" className="border border-gray-800 p-2 text-xs text-center">
                            <span className="font-bold mr-2">If attendance is low then reasons there of:</span>
                            <span className="inline-block border-b border-gray-600 min-h-[1.2em] w-3/5"></span>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

            {/* Interest Section */}
            <div className="mb-2">
                <div className="bg-orange-500 text-white py-1 px-3 text-sm font-bold inline-block">
                    INTEREST <span className="font-normal italic text-xs">(I (the student) am interested in)*:</span>
                </div>
            </div>
            <p className="text-xs text-gray-600 mb-2 italic">* May choose more than one option</p>

            <div className="border border-orange-300 p-3 bg-orange-50">
                <div className="space-y-2 text-sm mb-4">
                    {/* First row - Reading and Dancing */}
                    <div className="flex items-center justify-between">
                        <div className="flex items-center w-1/2">
                            <input
                                type="checkbox"
                                id="interest-reading"
                                className="mr-2"
                                readOnly
                                checked={data?.interests?.includes('reading') || false}
                            />
                            <label htmlFor="interest-reading" className="cursor-default">Reading</label>
                        </div>
                        <div className="flex items-center w-1/2">
                            <input
                                type="checkbox"
                                id="interest-dancing"
                                className="mr-2"
                                readOnly
                                checked={data?.interests?.includes('dancing_singing_instrument') || false}
                            />
                            <label htmlFor="interest-dancing" className="cursor-default">Dancing or Singing or Playing a
                                musical instrument</label>
                        </div>
                    </div>

                    {/* Second row - Sport and Creative writing */}
                    <div className="flex items-center justify-between">
                        <div className="flex items-center w-1/2">
                            <input
                                type="checkbox"
                                id="interest-sport"
                                className="mr-2"
                                readOnly
                                checked={data?.interests?.includes('sport_games') || false}
                            />
                            <label htmlFor="interest-sport" className="cursor-default">Sport or Games</label>
                        </div>
                        <div className="flex items-center w-1/2">
                            <input
                                type="checkbox"
                                id="interest-writing"
                                className="mr-2"
                                readOnly
                                checked={data?.interests?.includes('creative_writing') || false}
                            />
                            <label htmlFor="interest-writing" className="cursor-default">Creative writing</label>
                        </div>
                    </div>

                    {/* Third row - Gardening and Yoga */}
                    <div className="flex items-center justify-between">
                        <div className="flex items-center w-1/2">
                            <input
                                type="checkbox"
                                id="interest-gardening"
                                className="mr-2"
                                readOnly
                                checked={data?.interests?.includes('gardening') || false}
                            />
                            <label htmlFor="interest-gardening" className="cursor-default">Gardening</label>
                        </div>
                        <div className="flex items-center w-1/2">
                            <input
                                type="checkbox"
                                id="interest-yoga"
                                className="mr-2"
                                readOnly
                                checked={data?.interests?.includes('yoga') || false}
                            />
                            <label htmlFor="interest-yoga" className="cursor-default">Yoga</label>
                        </div>
                    </div>

                    {/* Fourth row - Art and Craft */}
                    <div className="flex items-center justify-between">
                        <div className="flex items-center w-1/2">
                            <input
                                type="checkbox"
                                id="interest-art"
                                className="mr-2"
                                readOnly
                                checked={data?.interests?.includes('art') || false}
                            />
                            <label htmlFor="interest-art" className="cursor-default">Art</label>
                        </div>
                        <div className="flex items-center w-1/2">
                            <input
                                type="checkbox"
                                id="interest-craft"
                                className="mr-2"
                                readOnly
                                checked={data?.interests?.includes('craft') || false}
                            />
                            <label htmlFor="interest-craft" className="cursor-default">Craft</label>
                        </div>
                    </div>

                    {/* Fifth row - Cooking (centered) */}
                    <div className="flex items-center justify-center">
                        <div className="flex items-center">
                            <input
                                type="checkbox"
                                id="interest-cooking"
                                className="mr-2"
                                readOnly
                                checked={data?.interests?.includes('cooking') || false}
                            />
                            <label htmlFor="interest-cooking" className="cursor-default">Cooking</label>
                        </div>
                    </div>

                    {/* Sixth row - Regular chores (full width) */}
                    <div className="flex items-center">
                        <input
                            type="checkbox"
                            id="interest-chores"
                            className="mr-2"
                            readOnly
                            checked={data?.interests?.includes('chores') || false}
                        />
                        <label htmlFor="interest-chores" className="cursor-default">Regular chores at home with
                            significant others (father, mother, guardian, sibling, etc.)</label>
                    </div>

                    {/* Last row - Other */}
                    <div className="flex items-center">
                        <input
                            type="checkbox"
                            id="interest-other"
                            className="mr-2"
                            readOnly
                            checked={!!data?.other_interest_specified}
                        />
                        <label htmlFor="interest-other" className="mr-2 cursor-default">Other</label>
                        <span className="text-xs italic mr-2">Please specify</span>
                        <span className="border-b border-gray-600 flex-1 min-h-[1.2em] pl-2 pb-1">
                            {data?.other_interest_detail || ''}
                        </span>
                    </div>
                </div>

                {/* Dotted lines for additional notes */}
                <div className="space-y-2">
                    <div className="border-b border-dotted border-gray-400 h-4"></div>
                    <div className="border-b border-dotted border-gray-400 h-4"></div>
                    <div className="border-b border-dotted border-gray-400 h-4"></div>
                    <div className="border-b border-dotted border-gray-400 h-4"></div>
                </div>
            </div>

            {/* Page number */}
            {pageNumber && (
                <div className="absolute bottom-4 left-0 right-0 text-center text-sm font-medium">
                    {pageNumber}
                </div>
            )}
        </div>
    );
};

export default PartA1;